export default "__VITE_ASSET__D1cPcQR8JGR3YSGfgIRyoQ__"